import state from './states';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';
import * as modules from '../pages/**/store/index.js'; //eslint-disable-line

export default {
  name: 'access-users',
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
  modules,
};



// WEBPACK FOOTER //
// ./src/features/private/settings/pages/access-users/store/index.js